import axios from 'axios'
import { LocalStorageService } from '../services'

class InvoiceUsePersonTypeService {
  constructor(apiUrl) {
    this.apiUrl = apiUrl
  }
  url = process.env.REACT_APP_MIFIRMA_API
  localStorageService = new LocalStorageService()

   /**
  * @author Lucia Alvarado
  * @description Get invoice use 
  * @date 20-10-2021
  * @param {String} token
  * @param {Object} taxData
  * @returns {Object}
  * @memberof InvoiceUsePersonTypeService
  */

  async getInvoiceUsePersonType (id, token) {
    let response = await axios.get(`${this.apiUrl}/invoice-use-person-type?personTypeId=${id}`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })
    return response.data.data
  }

   /**
  * @author Lucia Alvarado
  * @description Get invoice use 
  * @date 20-10-2021
  * @param {String} token
  * @param {Object} taxData
  * @returns {Object}
  * @memberof InvoiceUsePersonTypeService
  */

  async getAllInvoiceUsePersonTypes (token) {
    let response = await axios.get(`${this.apiUrl}/invoice-use-person-types`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })
    return response.data.data
  }
  

}

export { InvoiceUsePersonTypeService as default }
